export enum BankAccountStatusEnum {
    /**
     * Represents an active bank account
     */
    active = 0,
    /**
     * Represents a disabled bank account
     */
    disabled = 1,
    /**
     * Represents a bank account that had not been verified and does not need to be verified.
     * If you are checking if enabled, please also check for verified,
     * as they are both statuses that allows a bank account to be used.
     */
    enabled = 2,
    /**
     * Represents a verified bank account. This is the same as enabled, but with a past verification taking place.
     * If you are checking if verified, please also check for enabled, as they are both statuses that allows
     * a bank account to be used.
     */
    verified = 3,
    /**
     * Represents an historical bank account
     */
    historical = 4,
    /**
     * Represents a bank account that needs verification.
     */
    verificationRequired = 5
}
